<template>
    <div>
        <div class="VueTables__primary-content">{{ data.client_name }}</div>
        <div class="VueTables__secondary-content" v-if="prefixedName">{{ prefixedName }}</div>
    </div>
</template>

<script>
    export default {
        props: ['data', 'index', 'column'],
        computed: {
            prefixedName() {
                const {data} = this;

                if(data.client_prefixed_name == data.client_name) {
                    return '';
                }

                return data.client_prefixed_name
                    .replace(` - ${data.client_name}`,'')
                    .trim();
            }
        }
    }
</script>
